import { Breadcrumb } from "@refinedev/mui";
import { Box } from "@mui/material";
import PageHeading from "../../components/pageHeading";
export const IrregularRegularChildrenResumingAfterCheckInVisits = () => {
  return (
    <Box>
      <Breadcrumb />
      <PageHeading heading="Irregular & regular children resuming after check-in visits (%)" />
    </Box>
  );
};
